import {action, observable} from 'mobx';
import {observer, PropTypes as MobxPropTypes} from 'mobx-react';
import React from 'react';
import {Tooltip} from 'reactstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPlus} from '@fortawesome/free-solid-svg-icons';

import LoadingIcon from '../../../../common/loadingIcon/LoadingIcon';
import inject from '../../../../hoc/injectHoc';
import InputStringModal from '../../../../modals/inputString/InputStringModal';

import './folderAddButton.scss';

/**
 * The add folder button.
 */
export class FolderAddButton extends React.Component {
  /**
   * Whether or not the modal is open.
   *
   * @type {boolean}
   */
  @observable isNameModalOpen = false;

  /**
   * Whether or not the tooltip is open.
   *
   * @type {boolean}
   */
  @observable isTooltipOpen = false;

  /**
   * Triggered when the add button is clicked.
   */
  @action onNewFolderClick = () => {
    this.isNameModalOpen = true;
  };

  /**
   * Closes the name modal.
   */
  @action closeNameModal = () => {
    this.isNameModalOpen = false;
  };

  /**
   * Triggered when the name modal is completed.
   *
   * @param {string} newFolderName
   */
  @action onNameCreated = (newFolderName) => {
    if (!newFolderName) {
      this.isNameModalOpen = false;
      return;
    }

    const {apiContentFolderCreateStore} = this.props;

    apiContentFolderCreateStore.makeRequest(newFolderName);

    apiContentFolderCreateStore.getPromise().then(() => {
      this.closeNameModal();
    });
  };

  /**
   * Toggles the tooltip.
   */
  @action toggleTooltip = () => {
    this.isTooltipOpen = !this.isTooltipOpen;
  };

  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {
    const {apiContentFolderCreateStore} = this.props;

    const loading = () => (<LoadingIcon size="em" />);
    const notLoading = () => (<FontAwesomeIcon icon={faPlus} />);

    return (
      <div className="folder-add-button">
        <button
          type="button"
          className="btn btn-sm btn-default"
          id="folder-add-btn"
          onClick={this.onNewFolderClick}
        >
          {apiContentFolderCreateStore.case({
            pre: notLoading,
            pending: loading,
            fulfilled: notLoading,
            rejected: notLoading,
          })}
        </button>

        <Tooltip
          placement="right"
          isOpen={this.isTooltipOpen}
          target="folder-add-btn"
          toggle={this.toggleTooltip}
        >
          Create New Folder
        </Tooltip>

        {(this.isNameModalOpen) && (
          <InputStringModal
            isOpen={true}
            onComplete={this.onNameCreated}
            placeholder="New Folder Name"
            title="New Folder Name"
          />
        )}
      </div>
    );
  }
}

FolderAddButton.propTypes = {
  apiContentFolderCreateStore: MobxPropTypes.observableObject,
};

FolderAddButton.wrappedComponent = {};
FolderAddButton.wrappedComponent.propTypes = {
  apiContentFolderCreateStore: MobxPropTypes.observableObject.isRequired,
};

export default inject(FolderAddButton)(
  observer(FolderAddButton)
);
